import { SortingOptions } from "types/sortingOptions";

interface AdListSorterProps {
    sortOption: string;
    handleSortChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

export default function AdListSorter({ sortOption, handleSortChange }: AdListSorterProps) {
    return (
        <div className="d-flex align-items-center">
                <label htmlFor="sortSelect" className="me-2 text-nowrap">Sıralama:</label>
                <select 
                  id="sortSelect" 
                  className="form-select form-select-sm" 
                  value={sortOption}
                  onChange={handleSortChange}
                >
                  <option value={SortingOptions.NEWEST}>En Yeni Tarih</option>
                  <option value={SortingOptions.PRICE_ASC}>En Düşük Fiyat</option>
                  <option value={SortingOptions.PRICE_DESC}>En Yüksek Fiyat</option>
                </select>
              </div>
    )
}